
import type { PropType } from 'vue'
import type { ColorEnum } from '../../enums/color.enum'
import { RankingActionEnum } from '@empathybroker/tsclient-play/dist/enums/ranking-action.enum'
import { defineComponent } from 'vue'
import { useQueryRankingElementActionsConfig } from '../../composables/use-query-ranking-element-actions-config'
import { EpbButton } from '../shared/epb-button'

export default defineComponent({
  name: 'RankingResultCardActions',
  components: {
    EpbButton,
  },
  props: {
    action: {
      type: String as PropType<RankingActionEnum>,
      required: false,
      default: () => undefined,
    },
  },
  setup() {
    const { getActionConfig } = useQueryRankingElementActionsConfig()
    return { getActionConfig }
  },
  data() {
    return {
      baseClass: 'epb-ranking-result-card-actions',
      RankingActionEnum,
    }
  },
  methods: {
    onActionClick(action: RankingActionEnum): void {
      if (action === this.$props.action) {
        action = undefined
      }
      this.$emit('statusChange', action)
    },
    getActionText(action: RankingActionEnum): string {
      const selected = this.$props.action === action

      return this.getActionConfig(action, { negativeVariant: selected }).label
    },
    getActionColor(action: RankingActionEnum): ColorEnum {
      return this.getActionConfig(action).color
    },
    getActionSelected(action: RankingActionEnum): boolean {
      return {
        [RankingActionEnum.BOOST]: () => this.$props.action === RankingActionEnum.BOOST,
        [RankingActionEnum.BURY]: () => this.$props.action === RankingActionEnum.BURY,
      }[action]()
    },
  },
})
